// ko.js
export default {
    lang:'언어',
    menu:{
        supportApp: '애플리케이션 지원',
        supportBank: '지원 은행',
        openProcess: '개통 절차',
        successCase: '성공 사례',
        partners: '협력 동반자',
        contactUs: '연락하기'
    },
    tabs:{
        safe: '안전',
        safeContent: '전체 데이터 암호화',
        flexible: '유연한 배포',
        flexibleContent: '클라우드 배포 및 로컬 배포 유연성 선택 사항',
    },
    stayTuned: '기대하시길 바랍니다',
    supportAppPlatform:{
        title: '응용 플랫폼 지원',
        nsPlatform: '은행과 기업 직통 해결 방안',
        nscontent: '고객 재무 전용 컴퓨터에 설치된 클라이언트는 정기적으로 돌아가며 중간웨어 서비스를 제공하여 업무시스템의 지불 등 명령을 획득하고, 미리 설정한 비밀번호 해제와 상응한 은행조작을 실행하여 업무와 은행의 직접 연결 효과를 달성한다.이 방안은 안전문제가 없는바 지령이 전송과정에 전 과정에 암호화되며 클라이언트를 인트라넷컴퓨터에 설치하기에 외부망에 노출될 위험이 없다.지령 집행결과를 정기적으로 업무시스템에 피드백하는데, 전 과정을 문서로 기록하여 조사할 근거가 있다.',
        nsCorrespondingBank: '대응 은행',
        otherPlatform: '기타 응용 프로그램'
    },
    openProcess:{
        stepOne:{
            title: '은행',
            contentOne: '기업이 은행에 은행과 기업 간 직통',
            contentTwo: '연결 개설 허가를 신청하다',
        },
        stepTwo:{
            title: '은행과 기업 직접연결 플랫폼',
            contentOne: '플랫폼 사용자 등록',
            contentTwo: '개설 허가 권한'
        },
        stepThree:{
            title: 'ERP 응용 프로그램',
            contentOne: '설정을 설치하고',
            contentTwo: '디버깅을 실행합니다'
        },
        stepFour:{
            title: '개통',
            contentOne: '기능 시험',
            contentTwo: '정식 개통'
        } 
    },
    successCase:{
        yingtongTechnology: '鹰瞳科技',
        contentOne: '1. 은행기업과 회계정보동시화.계좌자금변화상황을 실시간으로 반영하여 기업의 재무감독통제와 결책에 편리를 도모해주며자금 흐름과 업무 흐름의 대조를 실현하다.',
        contentTwo: '2. 자금집중관리.자금풀을 건립하여 자금의 상하류 배분과 귀결을 실현하여 자금 이용 효율을 높이다.기업의 재무 결정을 위해 실시간, 정확하며 전면적인 회계 정보 지원을 제공하다',
        contentThree: '3. 시간을 절약하고 효익을 높인다.모든 지령을 한 번에 입력하여 재무인원의 수동조작 절차와 채산의 업무량을 줄이며 오류율을 효과적으로 줄인다.',
        contentFour: '4. 안전하고 안심할수 있다.인터넷뱅킹과 동일한 보안기능을 적용했을 뿐 계좌이체 거래에는 서명시간 필드를, 모든 거래에는 패킷 시퀀스 ID 필드를 각각 추가해 해킹과 명령어 중복 제출을 효과적으로 방지했다.'
    },
    contactUs:{
        content:'판매 전 팀은 당신을 위해 판매 전 자문, 상품 및 솔루션 추천, 설정 추천 등 서비스를 제공합니다. 은행과 기업의 상호 연결을 열 수 있도록 도와드립니다. 정보가 잘 통합니다!',
        name: '이름',
        nameRule: '이름을 입력하십시오',
        eMail: '메일 박스',
        eMailRule: '메일박스 입력',
        comp: '회사 명칭',
        compRule: '회사 이름을 입력하십시오',
        position: '직위',
        positionRule: '직위를 입력하십시오',
        mobile: '핸드폰 번호',
        mobileRule: '핸드폰 번호를 입력하세요',
        consuContent: '문의 내용',
        consuContentRule: '문의 내용을 채워 주십시오',
        sub: '제출'
    },
    showRightDataList:{
        console: '콘솔',
        exit: '종료',
        register: '로그인'
    },
    remarks:'Copyright©2022 엔터프라이즈 애플리케이션 및 은행 직접 연결 플랫폼',
    message:{
        language: '언어 설정 성공'
    }
}
  


// WEBPACK FOOTER //
// ./src/lang/ko.js